export default "__VITE_ASSET__D0UhlgLG__"